import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExchange = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M4.45625 6.3125C4.325 6.575 4.01875 6.68438 3.75625 6.575C3.49375 6.46563 3.3625 6.15938 3.47188 5.89688C4.21563 4.14688 5.96563 2.9 8 2.9C9.1375 2.9 10.2312 3.35938 11.0406 4.16875L12.2 5.32813V4.125C12.2 3.84063 12.4187 3.6 12.725 3.6C13.0094 3.6 13.25 3.84063 13.25 4.125V6.575C13.25 6.88125 13.0094 7.1 12.725 7.1H10.275C9.96875 7.1 9.75 6.88125 9.75 6.575C9.75 6.29063 9.96875 6.05 10.275 6.05H11.4562L10.2969 4.9125C9.68437 4.3 8.85312 3.95 8 3.95C6.40313 3.95 5.025 4.93438 4.45625 6.3125ZM12.5062 9.74688C11.7406 11.475 10.0125 12.7 8 12.7C6.84063 12.7 5.74688 12.2625 4.9375 11.4313L3.8 10.2938V11.475C3.8 11.7813 3.55938 12 3.275 12C2.96875 12 2.75 11.7813 2.75 11.475V9.025C2.75 8.74063 2.96875 8.5 3.275 8.5H5.725C6.00938 8.5 6.25 8.74063 6.25 9.025C6.25 9.33125 6.00938 9.55 5.725 9.55H4.52188L5.68125 10.7094C6.29375 11.3219 7.125 11.65 8 11.65C9.575 11.65 10.9531 10.7094 11.5219 9.33125C11.6531 9.04688 11.9594 8.9375 12.2219 9.04688C12.4844 9.15625 12.6156 9.4625 12.5062 9.74688Z"
	})
});
const ForwardRef = forwardRef(SvgExchange);
export default ForwardRef;
